export default __webpack_public_path__ + "static/media/277933effe4d81362a08.277933ef.svg";